import {
  CompactRecordList,
  NewRecordButton,
  RecordList,
  type RecordSlotProps,
} from '@databink/web/extension';

/**
 * Acme's screens around site surveys, built only from the web SDK. They add to core screens
 * through slots the core publishes; no core screen was edited to make room for them.
 */

/** The opportunity's pipeline for installations, where a survey comes before a quote. */
export const INSTALLATIONS = 'installations';

/** `crm.opportunity.detail.tabs`: the surveys booked for an installation opportunity, and a button to book one. */
export function OpportunitySurveys({ record }: RecordSlotProps) {
  const defaults: Record<string, string> = { opportunity_id: record.id };
  if (typeof record['party_id'] === 'string') defaults['party_id'] = record['party_id'];
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="max-w-2xl text-sm text-slate-600">
          An installation is surveyed before it is quoted. Completing a survey moves the opportunity
          to Surveyed, and it can be marked won only once a survey is complete.
        </p>
        <NewRecordButton entity="ext.site_survey" defaults={defaults}>
          Book a survey
        </NewRecordButton>
      </div>
      <RecordList
        entity="ext.site_survey"
        query={{
          filter: [{ field: 'opportunity_id', op: 'eq', value: record.id }],
          sort: { field: 'scheduled_on', dir: 'desc' },
        }}
        columns={[
          'site_address',
          'scheduled_on',
          'owner_id',
          'recommended_system',
          'heat_loss_kw',
          'state',
        ]}
        empty="No survey booked yet"
      />
    </div>
  );
}

/** `app.dashboard`: surveys booked from today on, soonest first, for everyone whose role can read surveys. */
export function UpcomingSurveys() {
  return (
    <CompactRecordList
      entity="ext.site_survey"
      filter={[
        { field: 'state', op: 'eq', value: 'scheduled' },
        { field: 'scheduled_on', op: 'gte', value: 'today' },
      ]}
      sort={{ field: 'scheduled_on', dir: 'asc' }}
      fields={['scheduled_on', 'party_id', 'owner_id']}
      aside="property_type"
      limit={6}
      empty="No surveys booked"
    />
  );
}
